import React from 'react';
import { Link } from 'react-router-dom';
import Background from '../components/Background';
import Navbar from '../components/Navbar';
import { metadata as post1 } from '../posts/hello-world';

const ALL_POSTS = [post1];

function formatDate(iso) {
  return new Date(iso).toLocaleDateString('en-US', {
    year: 'numeric', month: 'long', day: 'numeric',
  });
}

export default function BlogPage() {
  return (
    <div style={{ minHeight: '100vh', position: 'relative' }}>
      <Background />

      <div style={{
        position: 'relative', zIndex: 1,
        maxWidth: '700px',
        margin:   '0 auto',
        padding:  'clamp(4rem, 10vh, 8rem) 1.5rem 6rem',
      }}>
        {/* Back to home */}
        <Link to="/" style={{
          display:        'inline-block',
          fontFamily:     'var(--font-body)',
          fontSize:       '0.875rem',
          color:          'var(--color-text-secondary)',
          textDecoration: 'none',
          marginBottom:   '3rem',
          letterSpacing:  '0.02em',
        }}>
          ← TRLR
        </Link>

        <h1 style={{
          fontFamily:    'var(--font-display)',
          fontSize:      'clamp(2rem, 5vw, 3rem)',
          fontWeight:    400,
          color:         'var(--color-text-primary)',
          margin:        '0 0 3rem',
          letterSpacing: '0.02em',
        }}>
          Blog
        </h1>

        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
          {ALL_POSTS.map(post => (
            <li key={post.slug} style={{
              borderTop:  '1px solid var(--color-input-border)',
              padding:    '2rem 0',
            }}>
              <time style={{
                fontFamily:    'var(--font-body)',
                fontSize:      '0.8125rem',
                color:         'var(--color-text-secondary)',
                letterSpacing: '0.04em',
                display:       'block',
                marginBottom:  '0.5rem',
              }}>
                {formatDate(post.date)}
              </time>
              <Link to={`/blog/${post.slug}`} style={{ textDecoration: 'none' }}>
                <h2 style={{
                  fontFamily: 'var(--font-display)',
                  fontSize:   'clamp(1.25rem, 3vw, 1.625rem)',
                  fontWeight: 400,
                  color:      'var(--color-text-primary)',
                  margin:     '0 0 0.625rem',
                  transition: 'color 0.2s',
                }}>
                  {post.title}
                </h2>
              </Link>
              <p style={{
                fontFamily: 'var(--font-body)',
                fontSize:   '0.9375rem',
                color:      'var(--color-text-secondary)',
                margin:     0,
                lineHeight: 1.6,
              }}>
                {post.excerpt}
              </p>
              <Link to={`/blog/${post.slug}`} style={{
                display:        'inline-block',
                marginTop:      '1rem',
                fontFamily:     'var(--font-body)',
                fontSize:       '0.875rem',
                color:          'var(--color-accent)',
                textDecoration: 'none',
                letterSpacing:  '0.02em',
              }}>
                Read →
              </Link>
            </li>
          ))}
        </ul>
      </div>

      <Navbar />
    </div>
  );
}
